import React, { useState, useEffect } from 'react';
import { API_URL } from '../config/API_URLS.tsx';
import { authenticatedFetch } from '../auth/RequestSigner.tsx';

function MiniDashboardMoto() {
    const [capacity, setCapacity] = useState(0);
    const [inUse, setInUse] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchMotoData = async () => {
            try {
                const response = await authenticatedFetch(`${API_URL}/v1/parking-all-counter`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                
                if (!response.ok) {
                    throw new Error('Error en la solicitud');
                }
                
                const data = await response.json();
                setCapacity(data.capacity_motorcycle || 0);
                setInUse(data.motocycle_in_parking || 0);
            } catch (error) {
                console.error('Error al obtener datos de motos:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchMotoData();
    }, []);

    // Cálculo de porcentaje ocupado
    const occupancyPercentage = capacity > 0 ? Math.round((inUse / capacity) * 100) : 0;
    
    return (
        <div className="mini-dashboard-moto" data-testid="mini-dashboard-moto">
            {loading && (
                <div className="flex items-center" data-testid="mini-dashboard-moto-loading">
                    <div className="w-4 h-4 border-2 border-amber-500 border-t-transparent rounded-full animate-spin"></div>
                    <span className="ml-2 text-xs">Cargando...</span>
                </div>
            )}
            {!loading && (
                <div className="flex flex-col items-center" data-testid="mini-dashboard-moto-content">
                    <div className="relative" data-testid="mini-dashboard-moto-chart">
                        <svg className="w-16 h-16 transform -rotate-90" viewBox="0 0 36 36" data-testid="mini-dashboard-moto-svg">
                            <circle
                                cx="18"
                                cy="18"
                                r="15.9155"
                                fill="none"
                                stroke="#e6e6e6"
                                strokeWidth="3"
                                data-testid="mini-dashboard-moto-circle-bg"
                            />
                            <circle
                                cx="18"
                                cy="18"
                                r="15.9155"
                                fill="none"
                                stroke="#f5780b"
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeDasharray={`${occupancyPercentage}, 100`}
                                d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                                data-testid="mini-dashboard-moto-circle-progress"
                            />
                        </svg>
                        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-sm font-semibold" data-testid="mini-dashboard-moto-percentage">
                            {occupancyPercentage}%
                        </div>
                    </div>
                    <div className="mt-2 text-xs text-gray-600" data-testid="mini-dashboard-moto-count">
                        {inUse} / {capacity}
                    </div>
                </div>
            )}
        </div>
    );
}

export { MiniDashboardMoto };